import { useContext } from "react";
import { useMutation, useQuery } from "react-query";
import { ApiContext, EntitiesContext } from "../App";
import * as ActionTypes from "../constants/action-types";

const resource = "accounts";

export const useCreateAccount = () => {
  const api = useContext(ApiContext);
  const entities = useContext(EntitiesContext);

  return useMutation((account) => api.post(`/${resource}`, account), {
    onSuccess: (data) =>
      entities.dispatch({
        type: ActionTypes.RECEIVE_ENTITY,
        payload: data.data,
      }),
  });
};

export const useGetAccounts = (role = "vendor") => {
  const api = useContext(ApiContext);
  const entities = useContext(EntitiesContext);

  return useQuery(
    ["accounts", role],
    () => api.get(`/${resource}?role=${role}`),
    {
      onSuccess: (data) =>
        entities.dispatch({
          type: ActionTypes.RECEIVE_ENTITIES,
          payload: data.data,
        }),
    },
  );
};

export const useGetAccountOrders = account => {
  const api = useContext(ApiContext);
  const entities = useContext(EntitiesContext);

  return useQuery(
    ["account-orders", account.id],
    () => api.get(`/${resource}/${account.id}/orders`),
    {
      onSuccess: (data) =>
        entities.dispatch({
          type: ActionTypes.RECEIVE_ENTITIES,
          payload: data.data,
        }),
    },
  );
};

export const useUpdateAccount = () => {
  const api = useContext(ApiContext);
  const entities = useContext(EntitiesContext);

  return useMutation((account) =>
    api.put(`/${resource}/${account.id}`, account),
    {
      onSuccess: (item) =>
        entities.dispatch({
          type: ActionTypes.RECEIVE_ENTITY,
          payload: item.data,
        }),
    }
  );
};

export const useDeleteAccount = () => {
  const api = useContext(ApiContext);
  const entities = useContext(EntitiesContext);

  return useMutation((account) => api.delete(`/${resource}/${account.id}`), {
    onMutate: (item) =>
      entities.dispatch({
        type: ActionTypes.CLEAR_ENTITY,
        payload: {
          type: resource.slice(0, -1),
          id: item.id,
        },
      }),
  });
};

export const useGetAccountInventory = () => {
  const api = useContext(ApiContext);
  const entities = useContext(EntitiesContext);

  return useMutation(
    (account) => api.get(`/${resource}/${account.id}/inventory`),
    {
      onSuccess: (data) =>
        entities.dispatch({
          type: ActionTypes.RECEIVE_ENTITIES,
          payload: data.data,
        }),
    },
  );
};

export const useGetAccountAddress = () => {
  const api = useContext(ApiContext);
  const entities = useContext(EntitiesContext);

  return useMutation(
    (account) => api.get(`/${resource}/${account.id}/address`),
    {
      onSuccess: (data) =>
        entities.dispatch({
          type: ActionTypes.RECEIVE_ENTITY,
          payload: data.data,
        }),
    },
  );
};
